export default __webpack_public_path__ + "static/char-thumb-13-7634e7e90c1928cac0bb433557cf874c.png";